module.exports = __webpack_public_path__ + "images/saaremaa/apple-icon-120x120.png";